import moment from "moment";

import { LabMachineAnalysisFiletersFormData } from "../../../utils/types/components";
import { Sample } from "./types";

export const applyFilter = (
  registers,
  {
    sampleDates,
    states = [],
    machines = [],
  }: LabMachineAnalysisFiletersFormData,
): any => {
  const sampleFilter = ({
    estado,
    equipo_componente,
    fecha_muestra,
  }: Sample) => {
    if (!states.includes(estado as string)) return false;
    if (!machines.includes(equipo_componente as string)) return false;

    if (
      fecha_muestra &&
      sampleDates[0] &&
      !moment(fecha_muestra).isSameOrAfter(sampleDates[0], "day")
    )
      return false;

    if (
      fecha_muestra &&
      sampleDates[1] &&
      !moment(fecha_muestra).isSameOrBefore(sampleDates[1], "day")
    )
      return false;

    return true;
  };

  const samplesFiltered = registers.filter(sampleFilter);

  return samplesFiltered;
};
